var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{attrs:{"parent":"models_list"}},[_c('tab',{attrs:{"id":"articles","name":_vm.translate('device_models.articles'),"href":_vm.url+'articles'}},[_c('Articles')],1),_c('tab',{attrs:{"id":"models","name":_vm.translate('device_models.models'),"href":_vm.url+'models'}},[_c('Models')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }